import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import SentimentColor from 'components/design/SentimentColor';
import { CloudWord } from "./WordCloudContent";

interface WordCloudTooltipProps {
  topic: CloudWord
}

// Tooltip content component
export default function WordCloudTooltip(props: WordCloudTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  const topic: CloudWord = props.topic;

  return (
    <Box>
      <Typography variant="h3" sx={{ mb: topic.meta.entity ? 0 : 1, color: "inherit" }}>
        {topic.displayText}
      </Typography>
      {topic.meta.entity && 
        <Typography sx={{ mb: 1}}>
          {topic.meta.entity.type}
        </Typography>
      }
      <Typography>
        {i18n.t("positivity")}: 
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          <SentimentColor positivity={topic.meta.positivity}>
            {topic.meta.positivity === null ? `${i18n.t('neutral')}` : `${(topic.meta.positivity * 100).toFixed(1)}%` }
          </SentimentColor>
        </Box>
      </Typography>
      {topic.meta.relevance &&
        <Typography>
          {i18n.t("relevance")}:
          <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
            {topic.meta.relevance.toFixed(1)}
          </Box>
        </Typography>
      }
      <Typography>
        {i18n.t("record-count")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          {i18n.t('intlNumber', { val: topic.meta.count })}
        </Box>
      </Typography>
      <Typography>
        {i18n.t("distribution")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          {(topic.meta.distribution * 100).toFixed(2)}%
        </Box>
      </Typography>
      {topic.meta.velocity && <Typography>
        {i18n.t("velocity")}:
        <Box sx={{display:"inline-block", ml: 1, fontWeight:"bold"}}>
          {(topic.meta.velocity * 100).toFixed(1)}
        </Box>
      </Typography>}
    </Box>
  );
};
